import {useState} from 'react'
import {Contact} from '../type'
import {useUpdateWalletCardPublicMutation, useGetRawContactDetailQuery} from '../../../../../services/cellcast.v2'
import {ContactData} from '../../../../../services/cellcast.v2.types'
import {toast} from 'react-toastify'

export const useContactEdit = (onUpdateCallback?: () => void) => {
  const [isEditModalOpen, setIsEditModalOpen] = useState(false)
  const [selectedContact, setSelectedContact] = useState<Contact | null>(null)
  const [updateWalletCardPublic] = useUpdateWalletCardPublicMutation()
  const [showQmDrawer, setShowQmDrawer] = useState(false)
  const handleOpenEditModal = (contact: Contact) => {
    setSelectedContact(contact)
    setIsEditModalOpen(true)
  }

  // Fetch raw contact detail when a contact is selected for editing
  const {data: rawContactDetail} = useGetRawContactDetailQuery(
    {id: selectedContact?.id || ''},
    {refetchOnMountOrArgChange: true, refetchOnFocus: true}
  )

  const handleCloseEditModal = () => {
    setSelectedContact(null)
    setIsEditModalOpen(false)
  }

  const handleUpdateContact = async (updatedContact: Partial<ContactData>) => {
    const response: {data: ContactData} = (await updateWalletCardPublic(
      updatedContact as ContactData
    )) as unknown as {data: ContactData}
    if (response.data) {
      toast.success('Contact updated successfully')
      if (onUpdateCallback) {
        onUpdateCallback()
      }
    } else {
      toast.error('Failed to update contact')
    }
    handleCloseEditModal()
  }

  const handleShowQmDrawer = (contact: Contact) => {
    setSelectedContact(contact)
    setShowQmDrawer(true)
  }

  return {
    isEditModalOpen,
    // use merged fetched detail if available, otherwise fallback to selectedContact
    selectedContact: rawContactDetail?.data && selectedContact
      ? ({ ...selectedContact, ...rawContactDetail.data } as unknown as Contact)
      : selectedContact,
    showQmDrawer,
    setShowQmDrawer,
    handleOpenEditModal,
    handleCloseEditModal,
    handleUpdateContact,
    handleShowQmDrawer,
  }
}
